import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { epidemiologico2025 } from "../../../json/epidemiologico2025";

const Epidemiologico2025 = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Boletín Epidemiológico Semanal - Convencional (SUIVE)</h1>
          </div>
        </div>
      </div>
      <div className="steps-row row">
        {epidemiologico2025.map((item, index) => (
            <div key={index} className="col-sm-3 text-center" >
              <div>
              <a href={item.file_url} target="{_blank}"><img width="200"  src={item.img_url} /> <br/><div>{item.id_semana}</div>  </a>
              </div><br/>      
            </div>
          ))}
      </div>
    </div>
  );
};

export default Epidemiologico2025;
